<template>
  <a v-if="r.url" :href="r.url" target="_blank" class="quick" :class="{ 'has-icon': r.icon, 'quick--big': big, 'quick--hide': bounceIn === 1, 'quick--bounceIn': bounceIn === 2 }" :style="{ color: r.color }" v-bind="attribute">
    <icon class="quick-icon" :class="occasion && 'quick-icon--occasion'" v-if="r.icon" :name="r.icon || 'custom'" :bg="r.color" :fill="r.fill || 'white'" />
    <span class="quick-title">{{title}}</span>
  </a>
  <button v-else type="button" class="quick" @click.prevent="$emit('click')" :class="{ 'has-icon': r.icon, 'quick--big': big, 'quick--hide': bounceIn === 1, 'quick--bounceIn': bounceIn === 2 }" :style="{ color: r.color }" v-bind="attribute">
    <icon class="quick-icon" :class="occasion && 'quick-icon--occasion'" v-if="r.icon" :name="r.icon || 'custom'" :bg="r.color" :fill="r.fill || 'white'" />
    <span class="quick-title">{{title}}</span>
  </button>
</template>

<script>
import { removeEmoji } from '../util.js'

let firstRank = false
export default {
  props: {
    big: Boolean,
    r: null
  },
  computed: {
    attribute () {
      const value = typeof this.r.value !== 'undefined' ? this.r.value : this.r.title
      return this.r.model ? {
        ['data-choice-' + this.r.model]: value
      } : {
        'data-choice': value
      }
    },
    bounceIn () {
      // Only hide ranking
      if (this.r.next !== 'ranking') {
        return 0
      }
      // Hide until 4 likes
      if ((this.$root.state.likes || []).length < 4) {
        return 1
      }
      // Bounce it just 1 time
      return !firstRank && (firstRank = true) ? 2 : 3
    },
    occasion () {
      return this.r.icon && this.r.icon.indexOf('viewBox="0 0 34 34"') > 0
    },
    title () {
      return removeEmoji(this.r.title)
    }
  }
}
</script>

<style>
.quick {
  position: relative;
  margin: 0.5em;
  border: none;
  box-shadow: none;
  border-radius: 32px;
  line-height: 20px;
  padding: 10px 18px;
  background: #fff;
  color: #005ba9;
  outline: none;
  display: inline-block;
  box-sizing: border-box;
  font: inherit;
  -webkit-font-smoothing: unset;
  -moz-osx-font-smoothing: unset;
  text-decoration: none;
}
.quick + .quick {
  margin-left: 0.5em;
}
.quick.has-icon {
  padding-left: 50px;
}
.quick-icon.icon {
  position: absolute;
  left: 4px;
  top: 4px;
  bottom: 4px;
  height: 32px;
  width: 32px;
  padding: 4px;
  border-radius: 32px;
  font-size: 24px;
  box-sizing: border-box;
}
.quick-icon--occasion.icon {
  height: 32px;
  width: 32px;
  padding: 0;
}
.quick--big {
  padding: 0!important;
  width: 64px;
  height: 64px;
  opacity: .4;
  pointer-events: none;
}
.quick--big>.quick-icon {
  font-size: 48px;
  height: 56px;
  width: 56px;
}
.quick--big>.quick-title {
  display: none;
}
.quick--big:hover {
  opacity: 1;
}
.focus .quick--big {
  transition: opacity .2s;
  pointer-events: auto;
}
.overview .quick {
  max-width: 80%;
  max-width: calc(100% - 64px);
  overflow: hidden;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  text-align: left;
}

.quick--hide {
  display: none;
}
.quick--bounceIn {
  animation-duration: 1s;
  animation-name: bounceIn;
}

@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    opacity: 1;
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}
</style>
